import type { ReactNode } from 'react';

import useMedia from 'hooks/useMedia';

import { Container } from '@Atomic/molecules/Grid';

import styles from './style.module.scss';

type Props = {
  asideContent?: ReactNode;
  mainContent: ReactNode;
};

export const CatalogLayout = ({ asideContent, mainContent }: Props) => {
  const { xs, sm } = useMedia();
  const isMobile = xs || sm;

  return (
    <Container>
      <section className={styles.mainContent}>
        {!isMobile && asideContent ? (
          <aside className={styles.asideContent}>{asideContent}</aside>
        ) : null}
        <div className={styles.feedContent}>{mainContent}</div>
      </section>
    </Container>
  );
};
